import styled from 'styled-components';

import {
  Grid as SemanticGrid,
} from 'semantic-ui-react';

import { Segment as SegmentLayoutComponent } from '@playbookux/playbook-web-core';

const CardRow = styled(SemanticGrid.Row)`
  &&& {
    padding: 10px 0px;
    width: 100%;
  }
`;

const Segment = styled(SegmentLayoutComponent)`
  &&& {
    padding: 0px 10px;
    min-height: 72px;
    border: ${({ showOutline }) => (showOutline ? '1px solid red' : '1px solid #9c9ce120')};
  }
`;

export {
  CardRow,
  Segment,
};
